/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { client } from '@/sanity/client';
import { CategoryCard } from '../ui/CategoryCard';
import { ChevronRight } from 'lucide-react';

export const Services = () => {
	const [activeSlide, setActiveSlide] = useState(0);
	const [categories, setCategories] = useState<any[]>([]);

	useEffect(() => {
		const fetchCategories = async () => {
			const data =
				await client.fetch(`*[_type == "serviceCategory"] | order(order asc){
				name,
				description,
				image{
					asset->{
						url
					}
				},
				order
			}`);
			setCategories(data);
		};

		fetchCategories();
	}, []);

	const nextSlide = () => {
		setActiveSlide((prev) => (prev === categories.length - 1 ? 0 : prev + 1));
	};

	return (
		<section className='relative bg-[rgba(255,255,255,0.988)] flex flex-col items-center mx-3 px-8 md:px-20 rounded-[56px] max-md:max-w-full max-md:mr-2.5 max-md:px-5'>
			<div className='flex w-full max-w-[1329px] flex-col items-center py-16 max-md:max-w-full max-md:mb-2.5'>
				<p className='max-w-full md:w-3xl text-xl md:text-[25px] text-neutral-800 font-normal text-center leading-normal md:leading-[45px] mt-10 max-md:max-w-full'>
					Many speaking coaches concentrate solely on techniques, body language,
					voice modulation, and presentation skills. <br />
					<br />
					<span className='font-extrabold text-[rgba(251,176,64,1)]'>
						Yaap{' '}
					</span>
					recognises that genuine confidence originates from within. <br />
					We guide you through both the technical and emotional journey to
					uncover your <span className='font-bold'>authentic voice</span>
					<span className='font-bold text-[rgba(251,176,64,1)]'>.</span>
				</p>

				<img
					src='https://cdn.builder.io/api/v1/image/assets/17cfa75daf82417693353b2f7dd2694b/3187ace17fa2a5704e2f564b94c64501b34d46add8b6fe08114b934c4fc67d27?placeholderIfAbsent=true'
					alt='Divider'
					className='aspect-[0.13] object-contain w-2 mt-11 max-md:mt-10'
				/>

				<div className='self-stretch flex flex-col items-center text-neutral-800 text-center mt-11 max-md:max-w-full max-md:mt-10'>
					<h2 className='md:text-4xl font-bold leading-[40px] w-full max-w-[612px] max-md:max-w-full max-md:text-[30px] max-md:leading-[40px]'>
						Step Into Your Confidence with Our Growth-Focused Programs.
					</h2>
					<p className='max-w-full md:w-3xl text-xl md:text-[25px] text-neutral-800 font-normal text-center leading-normal md:leading-[45px] mt-10 max-md:max-w-full'>
						Discover the power of your God-given voice as we help you speak with
						clarity and conviction.
					</p>
				</div>

				{/* Desktop view - Grid */}
				<div className='hidden md:flex self-stretch mt-10 max-md:max-w-full md:px-8'>
					<div className='gap-8 flex w-full justify-center'>
						{categories.map((service, index) => (
							<div key={index} className='w-[28%]'>
								<CategoryCard
									title={service.name}
									description={service.description}
									backgroundImageUrl={service.image.asset.url}
									ctaText='View Services'
									ctaIconUrl='https://cdn.builder.io/api/v1/image/assets/17cfa75daf82417693353b2f7dd2694b/f7d1db1ff1aa6a55b8e802d6d3c3b0a0680740c3eb14c8159525488739489530?placeholderIfAbsent=true'
								/>
							</div>
						))}
					</div>
				</div>

				{/* Mobile view - Carousel */}
				<div className='md:hidden self-stretch w-full mt-10 overflow-hidden relative'>
					<div
						className='flex transition-all duration-500 ease-in-out'
						style={{ transform: `translateX(-${activeSlide * 100}%)` }}
					>
						{categories.map((service, index) => (
							<div key={index} className='w-full flex-shrink-0 px-2.5'>
								<CategoryCard
									title={service.name}
									description={service.description}
									backgroundImageUrl={service.image.asset.url}
									ctaText='View Services'
									ctaIconUrl='https://cdn.builder.io/api/v1/image/assets/17cfa75daf82417693353b2f7dd2694b/f7d1db1ff1aa6a55b8e802d6d3c3b0a0680740c3eb14c8159525488739489530?placeholderIfAbsent=true'
								/>
							</div>
						))}
					</div>

					{/* Carousel controls */}
					<div className='flex w-full items-center gap-5 justify-center mt-8'>
						<div className='flex items-center gap-2.5 my-auto p-2'>
							{categories.map((_, index) => (
								<button
									key={index}
									onClick={() => setActiveSlide(index)}
									className='focus:outline-none'
									aria-label='Service slide'
								>
									<div
										className={`${
											activeSlide === index
												? 'bg-[rgba(251,176,64,1)] h-4 w-4'
												: 'bg-[rgba(251,176,64,0.5)] h-3 w-3'
										} rounded-full transition-all duration-300`}
									/>
								</button>
							))}
						</div>
						<button
							onClick={nextSlide}
							className='flex items-center justify-center bg-[rgba(251,176,64,1)] rounded-full w-12 h-12 text-white transition-transform hover:scale-105 ml-4'
							aria-label='Next service'
						>
							<ChevronRight className='h-6 w-6' />
						</button>
					</div>
				</div>
				{/*  */}
			</div>
		</section>
	);
};
